module.exports = __webpack_public_path__ + "static/media/boss-heading.b99cbed1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/boss-heading.jpg
// module id = 129
// module chunks = 0